import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

type InputProps = InputHTMLAttributes<HTMLInputElement> & { invalid?: boolean }

export const Input = forwardRef<HTMLInputElement, InputProps>(({ className, invalid, ...rest }, ref) => {
  return (
    <input
      ref={ref}
      className={cn(
        'w-full h-10 px-3 rounded-md border bg-bg-surface text-fg-1 text-base',
        'transition-colors duration-fast ease-out',
        'placeholder:text-fg-3',
        'focus:outline-none focus:border-border-focus focus:ring-2 focus:ring-brand-500/20',
        invalid ? 'border-danger focus:ring-danger/20 focus:border-danger' : 'border-border',
        'disabled:bg-neutral-50 disabled:text-fg-disabled disabled:cursor-not-allowed',
        className,
      )}
      {...rest}
    />
  )
})
Input.displayName = 'Input'
